import React from 'react';
// Importa a nova função de logout
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
import './Navbar.css';
import logoImage from '../Login-logo.jpg';

function Navbar({ user }) {
  const handleLogout = () => {
    signOut(auth).catch(error => console.error("Erro no logout:", error));
  };

  return (
    <div className="navbar">
      <img src={logoImage} alt="Logo" className="navbar-logo" />
      <span className="navbar-brand">SISDengue Eunápolis</span>
      <div className="navbar-user">
        <span>{user.nome || user.email}</span>
        {/* Chama a nova função de logout */}
        <button onClick={handleLogout} className="logout-button">Sair</button>
      </div>
    </div>
  );
}

export default Navbar;